import styled from "styled-components"
import { mobile, mobilePortrait, tablet, medScreen, smallScreen } from "../../Responsive"

export const Container = styled.div`
    background-color: ${({ theme }) => theme.body};
`

export const Wrapper = styled.div`
    margin-top: 100px;
    padding: 20px;
    min-height: 85vh;
    display: flex;
    flex-direction: column;
    align-items: center;

    ${tablet({ marginTop: "80px"})}
    ${mobile({ marginTop: "60px", padding: "10px"})}
    ${mobilePortrait({ marginTop: "40px"})}
`

export const Header = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;
    width: 90vw;
`

export const Lines = styled.div`
    border: 1.5px solid var(--secondary);
    border-radius: 10px;
    margin-top: 20px;
    padding: 20px;
    width: 90vw;
    font-size: var(--fontM);

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontS);
        padding: 10px;
    }

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
        padding: 5px;
    }
`

export const Title = styled.h1`
    font-weight: 200;
    margin-bottom: 20px;
`

export const Display = styled.div`
    display: flex;

    ${tablet({ flexDirection: "column" })}    
`

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-width: 400px;
    margin-top: 10px;
    
    ${tablet({ maxWidth: "350px" })}   
`

export const GeneralInfo = styled.div`
    width: 40%;

    ${tablet({ width: "100%" })}        
`

export const Addresses = styled.div`
    display: flex;
    width: 60%;
    justify-content: space-between;

    ${tablet({ width: "100%" })}    
    ${mobile({ flexDirection: "column" })}    
`

export const AddressBlock = styled.div`
    margin-bottom: 10px;
`

export const AddressLine = styled.p``

export const InfoItem = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 5px;

    ${mobile({ flexDirection: "column", alignItems: "flex-start" })}   
`

export const InfoLabel = styled.span`
    font-size: var(--fontS);
    font-weight: 600;
    margin: 5px;
`

export const Info = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: ${({ theme }) => theme.body};
    font-size: var(--fontS);
    border: none;
    border-bottom: 1px solid var(--primary);
    border-right: 1px solid var(--primary);
    border-radius: 5px;
    min-height: 30px;
    width: 250px;
    padding: 5px;

    ${tablet({ width: "200px" })} 
`

export const ProductDetail = styled.div`
    display: flex;

    ${mobile({ flexDirection: "column" })}   
`

export const Image = styled.img`
    width: 400px;

    ${tablet({ width: "200px", objectFit: "cover" })}
    ${mobile({ width: "100px", objectFit: "cover" })}
`

export const Details = styled.div`
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: var(--fontS);

    @media screen and (max-width: ${medScreen}) {
        font-size: var(--fontXS);
        padding: 10px;
    }

    @media screen and (max-width: ${smallScreen}) {
        font-size: var(--fontXS);
        padding: 5px;
    }
`

export const ProductInfo = styled.span``
